import type { SxProps, Theme } from '@mui/material/styles';

import { MUI_SIZE } from '../../theme/controls';
import { type ControlSize, cssVar } from '../../theme/tokens';

export { MUI_SIZE };
export type { ControlSize };

/** Icon size inside a control: half the control height (16, 20, 24 px). */
export const iconSize = (size: ControlSize) => `calc(${cssVar(`control-h-${size}`)} / 2)`;

type SxEntry = Extract<SxProps<Theme>, readonly unknown[]>[number];

function toList(value: SxProps<Theme> | false | undefined): SxEntry[] {
  if (value === undefined || value === false) return [];
  return (Array.isArray(value) ? value : [value]) as SxEntry[];
}

/** Combines a component's own `sx` with the caller's (`sx` may be an array, an object or a fn). */
export function mergeSx(
  own: SxProps<Theme> | false | undefined,
  external: SxProps<Theme> | undefined,
): SxProps<Theme> {
  return [...toList(own), ...toList(external)];
}
